import type { DisciplineStageComment } from '../../interfaces'
import type { DisciplineCommentsStore } from './interfaces'

import { mergeStageComments, upsertStageComment } from '../../../lib/discipline-comments'

export const actions = {
  setLoading (this: DisciplineCommentsStore, payload: DisciplineCommentsStore['loading']): void {
    this.loading = payload
  },
  setComments (this: DisciplineCommentsStore, payload: DisciplineCommentsStore['comments']): void {
    this.comments = payload
  },
  appendComments (this: DisciplineCommentsStore, payload: DisciplineCommentsStore['comments']): void {
    this.comments = mergeStageComments(this.comments, payload)
  },
  upsertComment (this: DisciplineCommentsStore, payload: DisciplineStageComment): void {
    this.comments = upsertStageComment(this.comments, payload)
  },
  setNextCursor (this: DisciplineCommentsStore, payload: DisciplineCommentsStore['nextCursor']): void {
    this.nextCursor = payload
  },
  reset (this: DisciplineCommentsStore): void {
    this.comments = []
    this.nextCursor = null
  },
}
